import { useCallback } from 'react';
import { addMonths, subMonths, format } from 'date-fns';

export const useCalendarNavigation = (
  currentMonth: Date,
  setSelectedDate: (date: string | null) => void
) => {
  const goToPreviousMonth = useCallback(() => {
    const newDate = subMonths(currentMonth, 1);
    setSelectedDate(format(newDate, 'yyyy-MM-dd'));
  }, [currentMonth, setSelectedDate]);

  const goToNextMonth = useCallback(() => {
    const newDate = addMonths(currentMonth, 1);
    setSelectedDate(format(newDate, 'yyyy-MM-dd'));
  }, [currentMonth, setSelectedDate]);

  const goToToday = useCallback(() => {
    const today = new Date();
    setSelectedDate(format(today, 'yyyy-MM-dd'));
  }, [setSelectedDate]);

  return {
    goToPreviousMonth,
    goToNextMonth,
    goToToday
  };
};
